import { useMemo } from 'react';
export const useGroupImages = (images, activeTabIndex) => {
  const groupedData = useMemo(() => images.reduce((result, item) => {
    for (const code of item.categoryCode) {
      if (!result[code]) {
        result[code] = [];
      }
      result[code].push(item);
    }
    return {
      ...result
    };
  }, {
    all: images.map(index => index)
  }), [images]);
  const activeImages = useMemo(() => groupedData[Object.keys(groupedData).at(activeTabIndex)], [activeTabIndex, groupedData]);
  const smallImages = useMemo(() => activeImages.map(image => ({
    ...image,
    image_url: image.image_url.replace('?width=1000&height=165', '?width=165&height=93')
  })), [activeImages]);
  return {
    groupedData,
    activeImages,
    smallImages
  };
};